import { Loader2 } from "lucide-react";

export default function EmptyState({ icon: Icon, title, body, action, testid }) {
    return (
        <div
            data-testid={testid}
            className="rounded-lg border border-dashed border-border/80 bg-card/50 p-10 text-center"
        >
            {Icon ? <Icon className="mx-auto h-8 w-8 text-muted-foreground" strokeWidth={1.5} /> : null}
            <h3 className="mt-3 font-display text-lg font-semibold">{title}</h3>
            {body ? <p className="mt-1 text-sm text-muted-foreground max-w-md mx-auto">{body}</p> : null}
            {action ? <div className="mt-4">{action}</div> : null}
        </div>
    );
}

export function LoadingBlock({ label = "Loading" }) {
    return (
        <div className="flex items-center justify-center gap-2 py-12 text-muted-foreground text-sm font-mono">
            <Loader2 className="h-4 w-4 animate-spin" />
            {label}…
        </div>
    );
}
